<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { Patient } from '@/store/modules/patient/types'

const { t } = useI18n()

defineProps<{
  patient: Patient
  patientAge: number | null
  fullName: string
  pseudonymizationEnabled: boolean
}>()

function displayGender(gender: string): string {
  switch (gender) {
    case '1':
      return 'M'
    case '2':
      return 'F'
    case '3':
      return 'I'
    default:
      return gender
  }
}
</script>

<template>
  <div class="d-flex flex-column gap-2">
    <span class="ms-0 text-muted small">
      {{ t('stayDisplayer.patient') }}
    </span>
    <span class="ms-0 fw-bold">
      <template v-if="patientAge !== null">
        {{ t('stayDisplayer.yearsOld', { count: patientAge }) }} ({{ displayGender(patient.gender) }})
      </template>
      <template v-else>
        {{ t('stayDisplayer.patientData.notSpecified') }}
      </template>
    </span>
    <template v-if="!pseudonymizationEnabled">
      <span
        v-if="patient.birthDate"
        class="ms-0"
      >
        {{ patient.birthDate.format('DD/MM/YYYY') }}
      </span>
      <span class="ms-0">
        IPP {{ patient.ipp }}
      </span>
      <span class="ms-0">
        {{ fullName }}
      </span>
      <span
        v-if="patient.deathDate"
        class="ms-0 text-muted small"
      >
        {{ t('stayDisplayer.generalStayData.deathDate') }}:
        {{ patient.deathDate.format('DD MMM YYYY') }}
      </span>
    </template>
  </div>
</template>
